<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="计划ID" :value="2"></el-option>                           
                            <el-option label="计划名称" :value="1"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择" size="small">
                        <el-option label="不限制计划状态" value=""></el-option>
                        <el-option label="仅看进行中的" :value="1"></el-option>
                        <el-option label="仅看已完成的" :value="2"></el-option>
                        <el-option label="仅看已取消的" :value="3"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/activity/cps/oriented/save')" type="primary" icon="el-icon-plus" size="small"
                @click="add()">创建计划</el-button>
            <el-button
                v-if="$utils.have('/activity/cps/oriented/downloadList')"
                type="primary"
                icon="el-icon-download"
                @click="download"
                size="small"
                :loading="downLoading"
                >导出列表</el-button
            >
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="cpsId" label="计划ID" min-width="160"></el-table-column>
                <el-table-column prop="cpsName" label="计划名称" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="status" label="计划状态">
                    <template slot-scope="{row} = scope">
                        {{status[row.status]}}
                    </template>
                </el-table-column>               
                <el-table-column prop="contentType" label="计划类型" min-width="90">
					<template slot-scope="{row} = scope">
					    {{contentType[row.contentType]}}
					</template>
				</el-table-column>				
                <el-table-column prop="gmv" label="带货销售额"></el-table-column>
                <el-table-column prop="talentCommission" label="达人佣金" min-width="120"></el-table-column>
                <el-table-column prop="usedGmv" label="已核销订单金额" min-width="100" show-overflow-tooltip></el-table-column>
				<el-table-column prop="goodsNum" label="商品数量"></el-table-column>
				<el-table-column prop="talentNum" label="达人数量"></el-table-column>
				<el-table-column prop="contributeNum" label="投稿数"></el-table-column>
				<el-table-column prop="cutOffDate" label="数据累计截止日期" min-width="160"></el-table-column>
				<el-table-column prop="createTime" label="创建日期" min-width="160"></el-table-column>
                <el-table-column prop="modifyTime" label="更新日期" min-width="160"></el-table-column>
				<el-table-column prop="modifyUserName" label="更新操作人" min-width="120"></el-table-column>				
                <el-table-column fixed="right" label="操作" width="70">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/activity/cps/detail')"
                            type="text"
                            size="small"
                            @click="view(scope.row.id)"
                            >管理</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
       
    </div>
</template>
<script>
//import OpsEdit from  "./components/OpsEdit.vue"
const defaultParams = {
    pageNo: 1,
    searchType: 1,
    searchValue: "",
    status: ""
}
export default {
    components:{
       
    },
    data(){
        return{
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || "",
                status: parseInt(this.$route.query.status) || "",
            },
            listLoading: true,
            downLoading:false,
        }
    },
    computed:{
        status(){
            return{
                1:'进行中', 2:'已完成', 3:'已取消'
            }
        },
        contentType(){
            return{
                1:'仅短视频', 2:'仅直播间',
            }
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/activity/cps/oriented/list",
                method: "POST",
                data: {
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //导出
        download(){
            this.downLoading = true;
            this.$request({
                url: "/activity/cps/oriented/downloadList",
                method: "POST",
                data: {
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1 ) {
                        this.$confirm('下载任务创建成功,可以在下载任务列表查看', '提示', {
                            confirmButtonText: '立即查看',
                            cancelButtonText: '稍后再看',
                            type: 'success',
                            center: true,
                            closeOnClickModal: false
                        }).then(() => {
                            this.$router.push({path:'/workbench/downloadList'})
                        }).catch(() => {})
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.downLoading = false;
                });
        },
        //详情
        view(id){
            this.$router.push({
                path: `/promotion/ops/details/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },
		add(){
			this.$router.push({
			    path: `/promotion/ops/add`,
			    query: {
			        redirect: this.$utils.objArgs(
			            this.$router.currentRoute.path,
			            this.params
			        ),
			    },
			});
		}
       
    }
}
</script>
<style lang="scss" scoped>

</style>